/* Nalvani VacPack 40 — interacciones propias (prefijo vp-) */
(function () {
  'use strict';
  var reducido = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var editor = !!(window.Shopify && window.Shopify.designMode);

  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  /* Titulares palabra a palabra (respeta <em> y <br>) */
  function initPalabras() {
    $$('[data-vp-palabras]').forEach(function (el) {
      if (el.dataset.vpListo) return;
      el.dataset.vpListo = '1';
      var n = 0;
      (function envolver(nodo) {
        Array.prototype.slice.call(nodo.childNodes).forEach(function (hijo) {
          if (hijo.nodeType === 3) {
            var frag = document.createDocumentFragment();
            hijo.textContent.split(/(\s+)/).forEach(function (trozo) {
              if (!trozo) return;
              if (/^\s+$/.test(trozo)) { frag.appendChild(document.createTextNode(' ')); return; }
              var fuera = document.createElement('span'); fuera.className = 'vp-pal';
              var dentro = document.createElement('span'); dentro.textContent = trozo;
              dentro.style.setProperty('--w', n++);
              fuera.appendChild(dentro); frag.appendChild(fuera);
            });
            nodo.replaceChild(frag, hijo);
          } else if (hijo.nodeType === 1 && hijo.tagName !== 'BR') { envolver(hijo); }
        });
      })(el);
      el.classList.add('vp-reveal-pal');
    });
  }

  /* Entradas al hacer scroll */
  function initReveal() {
    var els = $$('.vp-reveal, .vp-reveal-pal, .vp-pasos__linea');
    if (reducido || editor || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('vp-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entradas) {
      entradas.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('vp-in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.14, rootMargin: '0px 0px -6% 0px' });
    els.forEach(function (el) { if (!el.classList.contains('vp-in')) io.observe(el); });
  }

  /* Parallax suave de hero y cierre (solo escritorio) */
  function initParallax() {
    var imgs = $$('[data-vp-parallax]');
    if (!imgs.length || reducido) return;
    var pendiente = false;
    function pintar() {
      pendiente = false;
      if (window.innerWidth < 750) return;
      imgs.forEach(function (img) {
        var caja = img.parentElement.getBoundingClientRect();
        if (caja.bottom < 0 || caja.top > window.innerHeight) return;
        var fuerza = parseFloat(img.dataset.vpParallax) || 6;
        var avance = (caja.top + caja.height / 2 - window.innerHeight / 2) / window.innerHeight;
        img.style.transform = 'translate3d(0,' + (-4 + avance * -fuerza).toFixed(2) + '%,0)';
      });
    }
    window.addEventListener('scroll', function () { if (!pendiente) { pendiente = true; requestAnimationFrame(pintar); } }, { passive: true });
    pintar();
  }

  /* Escena fija: ropa suelta → bolsas al vacío → mochila cerrada */
  function initPuente() {
    $$('[data-vp-puente]').forEach(function (sec) {
      var pista = sec.querySelector('.vp-puente__pista');
      var pasos = $$('.vp-puente__paso', sec);
      var fotos = $$('.vp-puente__escena img', sec);
      var barra = sec.querySelector('.vp-puente__barra span');
      var chip = sec.querySelector('[data-vp-chip]');
      var chipN = sec.querySelector('[data-vp-chip-n]');
      if (!pista || !pasos.length) return;
      var actual = -1;
      function activar(i) {
        if (i === actual) return;
        actual = i;
        pasos.forEach(function (p, k) { p.classList.toggle('vp-activo', k === i); });
        fotos.forEach(function (f, k) { f.classList.toggle('vp-activo', k === i); });
        if (chip) chip.textContent = pasos[i].dataset.titulo || '';
        if (chipN) chipN.textContent = (i + 1) + '/' + pasos.length;
      }
      function alScroll() {
        if (window.innerWidth < 990) return;
        var r = pista.getBoundingClientRect();
        var total = r.height - window.innerHeight;
        var p = total > 0 ? Math.min(1, Math.max(0, -r.top / total)) : 0;
        if (barra) barra.style.transform = 'scaleX(' + Math.max(0.02, p).toFixed(3) + ')';
        activar(Math.min(pasos.length - 1, Math.floor(p * pasos.length * 0.999)));
      }
      pasos.forEach(function (p, i) {
        p.addEventListener('click', function () {
          if (window.innerWidth < 990) return;
          var r = pista.getBoundingClientRect();
          var total = r.height - window.innerHeight;
          window.scrollTo({ top: window.scrollY + r.top + total * ((i + 0.5) / pasos.length), behavior: 'smooth' });
        });
      });
      activar(0);
      window.addEventListener('scroll', alScroll, { passive: true });
      window.addEventListener('resize', alScroll);
      alScroll();
    });
  }

  /* Comparador antes / después */
  function initComparador() {
    $$('[data-vp-comp]').forEach(function (marco) {
      var rango = marco.querySelector('input');
      if (!rango) return;
      function poner(v) { marco.style.setProperty('--p', v + '%'); }
      rango.addEventListener('input', function () { marco.dataset.tocado = '1'; poner(rango.value); });
      poner(rango.value);
      if (reducido || editor || !('IntersectionObserver' in window)) return;
      var io = new IntersectionObserver(function (es) {
        if (!es[0].isIntersecting) return;
        io.disconnect();
        var destino = parseFloat(rango.value), t0 = null;
        function paso(t) {
          if (marco.dataset.tocado) return;
          if (!t0) t0 = t;
          var k = Math.min(1, (t - t0) / 1800);
          var suave = 1 - Math.pow(1 - k, 3);
          var v = 96 - (96 - destino) * suave + Math.sin(k * Math.PI) * -14;
          poner(Math.max(4, v)); rango.value = v;
          if (k < 1) requestAnimationFrame(paso); else { rango.value = destino; poner(destino); }
        }
        requestAnimationFrame(paso);
      }, { threshold: 0.45 });
      io.observe(marco);
    });
  }

  /* Acordeones */
  function initAcordeon() {
    $$('.vp-acc__btn').forEach(function (btn) {
      if (btn.dataset.vpListo) return;
      btn.dataset.vpListo = '1';
      btn.addEventListener('click', function () {
        var item = btn.closest('.vp-acc');
        var grupo = item.parentElement;
        var abrir = !item.classList.contains('vp-abierto');
        if (grupo.dataset.vpAcc === 'unico') {
          $$('.vp-acc.vp-abierto', grupo).forEach(function (o) {
            o.classList.remove('vp-abierto');
            o.querySelector('.vp-acc__btn').setAttribute('aria-expanded', 'false');
          });
        }
        item.classList.toggle('vp-abierto', abrir);
        btn.setAttribute('aria-expanded', abrir ? 'true' : 'false');
      });
    });
  }

  /* Página de producto: galería, cantidad, variantes y barra flotante */
  function dinero(centimos) {
    var fmt = window.vpMoneyFormat || '${{amount}}';
    var valor = (centimos / 100).toFixed(2);
    var partes = valor.split('.');
    var conComas = partes[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, tipo) {
      if (tipo === 'amount_no_decimals') return conComas;
      if (tipo === 'amount_with_comma_separator') return partes[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + partes[1];
      if (tipo === 'amount_no_decimals_with_comma_separator') return partes[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      return conComas + '.' + partes[1];
    });
  }
  function initProducto() {
    var raiz = document.querySelector('[data-vp-producto]');
    if (!raiz) return;
    var fotos = $$('.vp-prod__principal > img', raiz);
    var minis = $$('.vp-prod__mini', raiz);
    var cuenta = raiz.querySelector('[data-vp-cuenta]');
    var idx = Math.max(0, fotos.findIndex(function (f) { return f.classList.contains('vp-activo'); }));
    function ver(i) {
      if (!fotos.length) return;
      idx = (i + fotos.length) % fotos.length;
      fotos.forEach(function (f, k) { f.classList.toggle('vp-activo', k === idx); });
      minis.forEach(function (m, k) { m.classList.toggle('vp-activo', k === idx); });
      if (cuenta) cuenta.textContent = (idx + 1) + ' / ' + fotos.length;
      if (minis[idx] && minis[idx].parentElement.scrollTo) {
        var cont = minis[idx].parentElement;
        cont.scrollTo({ left: minis[idx].offsetLeft - cont.clientWidth / 2 + 38, behavior: 'smooth' });
      }
    }
    minis.forEach(function (m, k) { m.addEventListener('click', function () { ver(k); }); });
    var prev = raiz.querySelector('[data-vp-prev]'), next = raiz.querySelector('[data-vp-next]');
    if (prev) prev.addEventListener('click', function () { ver(idx - 1); });
    if (next) next.addEventListener('click', function () { ver(idx + 1); });
    var principal = raiz.querySelector('.vp-prod__principal');
    if (principal) {
      var x0 = null;
      principal.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
      principal.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0; x0 = null;
        if (Math.abs(dx) > 40) ver(idx + (dx < 0 ? 1 : -1));
      });
    }

    var cantidad = raiz.querySelector('input[name="quantity"]');
    $$('[data-vp-qty]', raiz).forEach(function (b) {
      b.addEventListener('click', function () {
        cantidad.value = Math.max(1, (parseInt(cantidad.value, 10) || 1) + parseInt(b.dataset.vpQty, 10));
      });
    });

    var form = raiz.querySelector('form[action*="/cart/add"]');
    var inputId = raiz.querySelector('input[name="id"]');
    var boton = raiz.querySelector('[data-vp-anadir]');
    var estado = raiz.querySelector('[data-vp-estado]');
    var precio = raiz.querySelector('[data-vp-precio]');
    var antes = raiz.querySelector('[data-vp-antes]');
    var barra = document.querySelector('[data-vp-barra]');
    var datos = raiz.querySelector('[data-vp-variantes]');
    if (datos) {
      var variantes = JSON.parse(datos.textContent);
      var grupos = $$('[data-vp-opcion]', raiz);
      grupos.forEach(function (g) {
        $$('.vp-prod__pill', g).forEach(function (pill) {
          pill.addEventListener('click', function () {
            $$('.vp-prod__pill', g).forEach(function (o) { o.classList.remove('vp-activo'); o.setAttribute('aria-pressed', 'false'); });
            pill.classList.add('vp-activo'); pill.setAttribute('aria-pressed', 'true');
            var et = g.querySelector('[data-vp-opcion-valor]');
            if (et) et.textContent = pill.dataset.etiqueta;
            var elegidas = grupos.map(function (x) { return x.querySelector('.vp-prod__pill.vp-activo').dataset.valor; });
            var v = variantes.filter(function (c) { return c.options.join('|') === elegidas.join('|'); })[0];
            var txt = boton.querySelector('span');
            if (!v) { boton.disabled = true; txt.textContent = boton.dataset.noDisp; return; }
            inputId.value = v.id;
            boton.disabled = !v.available;
            txt.textContent = v.available ? boton.dataset.disp : boton.dataset.agot;
            if (precio) precio.textContent = dinero(v.price);
            if (antes) { antes.hidden = !(v.compare_at_price > v.price); antes.textContent = dinero(v.compare_at_price || 0); }
            if (estado) { estado.classList.toggle('vp-sin', !v.available); estado.querySelector('span').textContent = v.available ? estado.dataset.disp : estado.dataset.agot; }
            if (barra) { var bp = barra.querySelector('[data-vp-barra-precio]'); if (bp) bp.textContent = dinero(v.price); var bb = barra.querySelector('[data-vp-barra-btn]'); if (bb) bb.disabled = !v.available; }
            if (v.media_pos !== null) ver(v.media_pos);
            var url = new URL(window.location.href); url.searchParams.set('variant', v.id);
            window.history.replaceState({}, '', url.toString());
          });
        });
      });
    }

    var secundario = raiz.querySelector('[data-vp-carrito]');
    if (secundario && form) {
      secundario.addEventListener('click', function () {
        var destino = form.querySelector('input[name="return_to"]');
        if (destino) destino.parentNode.removeChild(destino);
        if (form.requestSubmit) form.requestSubmit(); else form.submit();
      });
    }

    if (barra && boton) {
      var bbtn = barra.querySelector('[data-vp-barra-btn]');
      if (bbtn) bbtn.addEventListener('click', function () { if (form.requestSubmit) form.requestSubmit(boton); else form.submit(); });
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (es) {
          var e = es[0];
          barra.classList.toggle('vp-visible', !e.isIntersecting && e.boundingClientRect.top < 0);
        }).observe(boton);
      }
    }
  }

  function iniciar() {
    initPalabras(); initReveal(); initParallax(); initPuente(); initComparador(); initAcordeon(); initProducto();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar); else iniciar();
  /* Editor de Shopify: al añadir o recargar una sección, todo visible y funcional */
  document.addEventListener('shopify:section:load', function () { initPalabras(); initReveal(); initAcordeon(); initComparador(); });
})();
